import { ORDER_METHODS } from '../../../../../../../services/exports/Constants';

export default {
  order_methods: {
    delivery: 'Livraison',
    pickup: 'À emporter',
    room_service: 'Sur place',
    table_service: 'Sur place',
  },
  asap: 'ASAP',
  unavailable: 'Indisponible',
  ready_in_time: 'Prêt dans {{time}} min',
  locations: {
    [ORDER_METHODS.DELIVERY]: 'Livraison à {{address}}',
    [ORDER_METHODS.PICKUP]: 'À emporter à {{address}}',
    [ORDER_METHODS.ROOM_SERVICE]: 'Sur place à {{address}}',
  },
  buttons: {
    change: 'Modifier',
    see_hours: 'Voir les horaires',
    change_location: 'Changer de lieu',
    change_time: "Changer l'heure",
  },
};
